document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const html = document.documentElement;
  const body = document.body;
  const content = drawer.querySelector('[data-cart-drawer-content]');
  const toggleButton = document.querySelector('[data-toggle-cart]');
  const slideMenu = document.getElementById('slideMenu');
  const header = document.querySelector('.tgl-header');
  const drawerCount = drawer.querySelector('[data-cart-drawer-count]');

  const discountStorageKey = 'tglDiscountCode';
  const drawerStateKey = 'tglCartDrawerOpen';

  const applyDiscount = (code) => {
    if (!code) return;
    localStorage.setItem(discountStorageKey, code);
    localStorage.setItem(drawerStateKey, 'true');
    const redirect = encodeURIComponent(`${window.location.pathname}${window.location.search}${window.location.hash}`);
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${redirect}`;
  };

  const getStoredDiscount = () => localStorage.getItem(discountStorageKey);

  const syncStoredDiscount = () => {
    const summary = drawer.querySelector('[data-cart-discount-active]');
    if (!summary) return;
    const hasDiscount = summary.dataset.cartDiscountActive === 'true';
    const discountCode = summary.dataset.cartDiscountCode || '';
    if (!hasDiscount) {
      localStorage.removeItem(discountStorageKey);
      return;
    }
    if (discountCode && !getStoredDiscount()) {
      localStorage.setItem(discountStorageKey, discountCode);
    }
  };

  const goToCheckoutWithDiscount = (code) => {
    if (!code) return false;
    window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
    return true;
  };

  const openDrawer = () => {
    if (slideMenu && slideMenu.classList.contains('active')) {
      slideMenu.classList.remove('active');
      html.classList.remove('tgl-menu-open');
      body.classList.remove('tgl-menu-open');
      if (header) {
        header.classList.remove('menu-open');
      }
    }
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    html.classList.add('tgl-cart-open');
    body.classList.add('tgl-cart-open');
    if (header) {
      header.classList.add('cart-open');
    }
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    html.classList.remove('tgl-cart-open');
    body.classList.remove('tgl-cart-open');
    if (header) {
      header.classList.remove('cart-open');
    }
  };

  const fetchCart = () => fetch('/cart.js').then((response) => response.json());

  const updateCartCount = (cart) => {
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
    } else if (cart.item_count > 0) {
      const cartLink = document.querySelector('.cart-link');
      if (cartLink) {
        const newCount = document.createElement('span');
        newCount.className = 'cart-count';
        newCount.textContent = cart.item_count;
        cartLink.appendChild(newCount);
      }
    }

    if (drawerCount) {
      drawerCount.textContent = `(${cart.item_count})`;
    }
  };

  const refreshDrawer = () =>
    fetch('/?section_id=cart-drawer')
      .then((response) => response.text())
      .then((htmlText) => {
        if (!content) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const nextContent = doc.querySelector('[data-cart-drawer-content]');
        if (nextContent) {
          content.innerHTML = nextContent.innerHTML;
        }
      });

  const refresh = () =>
    fetchCart()
      .then((cart) => {
        updateCartCount(cart);
        return refreshDrawer();
      })
      .then(() => {
        syncStoredDiscount();
      })
      .catch((error) => {
        console.error('Error refreshing cart drawer:', error);
      });

  const updateQuantity = (itemId, quantity) =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [itemId]: quantity } })
    })
      .then(() => refresh())
      .catch((error) => {
        console.error('Error updating cart:', error);
      });

  const addItem = (formData, options = {}) =>
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(() => refresh())
      .then(() => {
        if (options.openDrawer === false) return;
        openDrawer();
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        throw error;
      });

  if (toggleButton) {
    toggleButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (drawer.classList.contains('active')) {
        closeDrawer();
      } else {
        openDrawer();
        refresh();
      }
    });
  }

  drawer.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest('[data-cart-drawer-close]');
    if (closeTrigger) {
      closeDrawer();
      return;
    }

    const removeButton = event.target.closest('.item-remove');
    if (removeButton) {
      updateQuantity(removeButton.dataset.itemId, 0);
      return;
    }

    const quantityButton = event.target.closest('.quantity-btn');
    if (quantityButton) {
      const action = quantityButton.dataset.action;
      const itemId = quantityButton.dataset.itemId;
      const input = drawer.querySelector(`.quantity-input[data-item-id="${itemId}"]`);
      const currentValue = parseInt(input?.value, 10) || 1;

      if (action === 'increase') {
        updateQuantity(itemId, currentValue + 1);
      } else if (action === 'decrease' && currentValue > 1) {
        updateQuantity(itemId, currentValue - 1);
      }
    }
  });

  drawer.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-discount-form]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('[data-discount-input]');
    const code = input ? input.value.trim() : '';
    applyDiscount(code);
  });

  drawer.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('.checkout-btn');
    if (!checkoutButton) return;
    const code = getStoredDiscount();
    if (!code) return;
    event.preventDefault();
    goToCheckoutWithDiscount(code);
  });

  drawer.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.classList.contains('quantity-input')) return;

    const itemId = event.target.dataset.itemId;
    const newQuantity = Math.max(1, parseInt(event.target.value, 10) || 1);
    event.target.value = newQuantity;
    updateQuantity(itemId, newQuantity);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });

  document.querySelectorAll('.product-form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const button = form.querySelector('.add-to-cart-btn');
      const originalText = button ? button.textContent : '';
      if (button) {
        button.textContent = 'Adding...';
        button.disabled = true;
      }

      addItem(new FormData(form))
        .then(() => {
          if (button) {
            button.textContent = 'Added!';
          }
        })
        .catch(() => {
          if (button) {
            button.textContent = 'Error';
          }
        })
        .finally(() => {
          if (button) {
            setTimeout(() => {
              button.textContent = originalText || 'Add to Cart';
              button.disabled = false;
            }, 1500);
          }
        });
    });
  });

  const restoreDrawerState = () => {
    if (localStorage.getItem(drawerStateKey) === 'true') {
      localStorage.removeItem(drawerStateKey);
      openDrawer();
      refresh();
    }
  };

  syncStoredDiscount();
  restoreDrawerState();

  window.TGLCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh,
    addItem,
    updateCartCount
  };
});
